import { render, staticRenderFns } from "./FansPanel.vue?vue&type=template&id=6ec686bb"
import script from "./FansPanel.vue?vue&type=script&lang=ts"
export * from "./FansPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports